module.exports = "/packs/images/homepage/whatson/october_offers_retina~ccdb385617d1f77939d9b347a3dcc3d9.jpg";